export const CUSTOM_FORM_KEY_PREFIX = 'cfe-';
